import axios from "axios"
import { useEffect, useState } from "react"
import { invoiceStatusRead, supplierDocuments, suppliersRead } from "../Supplier"
import { Box, Button, Menu, MenuItem, Select, TextField } from "@mui/material"
import moment from "moment"
import { dynamicSort } from "../utils/function"

export default function CheckStatusPage() {
    const [sendersList,setSenderList]=useState([])
    const [peppolList,setPeppolList]=useState([])

    const [senders,setSender]  = useState(null)
    const [idPeppol,setIdPeppol] = useState(null)
    const [res,setRes] = useState(null)
    useEffect(()=>{
        suppliersRead().then(data=>{console.log(data)
            setSenderList(
                data.map
                (i=>({id:i[0],name:i[1],apiKey:i[2],status:i[3]||"active"}))
            )
        }
        )
    },[])
    useEffect(()=>{
        console.log("????",senders)
        if(senders){
            supplierDocuments(senders).then(data=>setPeppolList(data.sort((a, b) => new Date(b[1]) - new Date(a[1]))))
        }
    },[senders])
    console.log("DATA",peppolList)
    const handleCheck =()=>{
        console.log("Check")
        setRes(null)
        invoiceStatusRead(senders,idPeppol).then(
            data=>{setRes(data);console.log("DATA",data)}
        ).catch(e=>console.log(e))
    }
    useEffect(()=>{
        console.log(res?.data||"vide")
    },[res])
    
    return (
        <div>
        <h1>Verification de documents </h1>
        <Box style={{minWidth:'100%',display:'flex',flex:1,justifyContent:'space-between'}} id='search'>
            <Select
            style={{flex:0.8,marginRight:15}} placeholder="Emmetteur"
                onChange={(e,id)=>setSender(id.props.value)}
            >
                {sendersList.map(e=>{
                    if(e.status==="active"){

                        return(
                            <MenuItem key={e.id} value={e.id} >{e.name}</MenuItem>)
                     }
                })
                

            }
            </Select>
            <Select style={{flex:1}} placeholder='Document'
                onChange={(e,id)=>setIdPeppol(id.props.value)}
            >
                {peppolList.map(e=>{
                    console.log("EE",e)
                    return(
                        <MenuItem key={e[0]} value={e[0]}>
                            {`${moment(e[1]).format("DD/MM/YYYY")} - ${e[0]} `}
                        </MenuItem>
                    )
                })}
            </Select>
       
        </Box>
        <Button variant="outlined" style={{padding:10,margin:10,alignSelf:'flex-end'}} onClick={handleCheck}>Vérifier</Button>
            {res?.data &&(
                <Box>
                <span style={{color:res.data.attributes.status==="invalid"?"red":"green"}}>
                <h1>{res.data.attributes.status==="invalid"?"Invalide":"Envoyée"}</h1>
                </span>
                <div>
                    {res.data.attributes.errors?.map(e=>{
                        return(
                            <Box>
                            <div> <h2>code : {e.code}</h2></div>
                            <div><h3> détails :</h3> {e.detail.split('\n').map((item, idx) => (
              <p key={idx} className="error-detail">
                {item}
              </p>
            ))} </div>
                            </Box>
                        )
                    })}
                </div>
                </Box>
            )}
        </div>
    )

}